import { useCallback, useState } from 'react';
/**Хук useCollapse
 * @param initialState - первоначальное значение открыт ли коллапс
 * @returns [isOpen, toggleCollapse] - возврашет isOpen значение открыт или нет и
 * toggleCollapse(value: boolean = null) функция обновления isOpen, атрибут value не обязательный, если не передать value сменит на противоположное
 */
function useCollapse(initialState = false) {
    const [isOpen, setIsOpen] = useState(initialState);
    const toggleCollapse = useCallback((value = null) => {
        setIsOpen(value ? value : !isOpen);
    }, [isOpen]);
    return [isOpen, toggleCollapse];
}
export { useCollapse };
//# sourceMappingURL=useCollapse.js.map